import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
export function SetupAccordion({ children, title }) {
    const [isOpen, setIsOpen] = useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-4",
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                onClick: ()=>setIsOpen(!isOpen),
                className: "w-full flex items-center justify-between bg-blue-50 hover:bg-blue-100 text-blue-900 rounded-md px-4 py-3 transition-colors",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-medium text-sm",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("svg", {
                        className: `w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`,
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M19 9l-7 7-7-7"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ _jsx("div", {
                className: "mt-2 bg-gray-50 rounded-md p-4 text-sm text-gray-700 space-y-3",
                children: children
            })
        ]
    });
}
